<template>
  <el-dialog title="导入记录" :visible.sync="dialogTableVisible" :before-close="closeDialog" width="800px" :close-on-click-modal="false">
    <el-table :data="tableData" v-loading="loading" max-height="550">
      <el-table-column prop="optCreateTime" label="导入时间" width="150"></el-table-column>
      <el-table-column prop="total" label="导入数量" width="200"></el-table-column>
      <el-table-column prop="createOrderNum" label="成功量"></el-table-column>
      <el-table-column prop="failNum" label="失败量"></el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <span class="systemColor y-c-p" @click="downloadFn(scope.row.failFileUrl)" v-if="scope.row.failFileUrl">下载导入结果文件</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNo"
      :page-sizes="[10, 20, 50]"
      :page-size="limit"
      layout="total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination>
  </el-dialog>
</template>
<script>
import util, { downloadFileUrl } from '@/utils/util';
import { importResultRecordForSpecialOrderApi } from '@/api/waybillPrint/sepecialOrderPrint'
export default {
  name: "record-list",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogTableVisible: this.isShow,
      tableData: [],
      loading: false,
      pageNo: 1,
      limit: 10,
      total: 0,
    };
  },
  methods: {
    downloadFn(fileUrl) {
      downloadFileUrl(util.picUrl + fileUrl);
    },
    getDetailList() {
      // 获取列表
      this.loading = true;
      this.tableData = [];
      let params = { 
        pageNumber: this.pageNo,
        pageSize: this.limit
      };
      importResultRecordForSpecialOrderApi(params).then((res) => {
        this.loading = false;
        if (res.success && res.data) {
          this.tableData = res.data.lists || [];
          this.total = res.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }        
      }).catch(()=>{
        this.tableData = [];
        this.total = 0;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      // 页码改变
      this.limit = val;
      this.getDetailList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDetailList();
    },
    closeDialog() {
      this.dialogTableVisible = false;
      this.$emit("closeDialog");
    },
  },
  mounted() {
    this.getDetailList();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>